import styled from '@emotion/styled';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import {
  faCircleThreeQuartersStroke,
  faShieldCheck,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Ring from '~/common/components/Ring';
import { ALERT_TYPES, RULE_RESULT_STATUS_ID } from '~/common/constants';

const StyledCheckIcon = styled<any>(FontAwesomeIcon)((props) => ({
  color: props.theme.colors?.green[600],
  fontSize:
    props.size === 'small'
      ? props.theme.functions?.pixelsToRem(16)
      : props.theme.functions?.pixelsToRem(20),
}));

export const StyledCircleIcon = styled<any>(FontAwesomeIcon)((props) => ({
  color: props.required
    ? props.theme.colors?.red[600]
    : props.theme.colors?.orange[300],
  fontSize:
    props.size === 'small'
      ? props.theme.functions?.pixelsToRem(16)
      : props.theme.functions?.pixelsToRem(20),
}));

const StyledNotification = styled<any>('span')((props) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold',
  borderRadius: '50%',
  lineHeight: '150%',
  minHeight: props.size === 'small' ? '16px' : '20px',
  minWidth: props.size === 'small' ? '16px' : '20px',
  color: props.required ? props.theme.colors?.white : props.theme.colors?.black,
  backgroundColor: props.required
    ? props.theme.colors?.red[600]
    : props.theme.colors?.orange[300],
  fontSize:
    props.size === 'small'
      ? props.theme.functions?.pixelsToRem(10)
      : props.theme.functions?.pixelsToRem(12),
  border: `1px solid
      ${
        props.required
          ? props.theme.colors?.red[600]
          : props.theme.colors?.orange[300]
      }`,
}));

type StatusIconProps = {
  type?: any | any | any | any;
  status?: any | any | any | any;
  numberOfChildren?: number;
  required?: boolean;
  size?: 'big' | 'small';
  canSeeVerification?: boolean;
};

const StatusIcon = ({
  type,
  status,
  numberOfChildren,
  required,
  size,
  canSeeVerification,
}: StatusIconProps) => {
  switch (true) {
    case status === RULE_RESULT_STATUS_ID.VERIFIED:
      return (
        <StyledCheckIcon
          size={size}
          icon={faShieldCheck}
          data-testid="status-icon-shield"
        />
      );
    case status === RULE_RESULT_STATUS_ID.AUTOMATED_BOLT_SHIELD:
      return <img src="/images/bolt-shield.svg" alt="bolt shield" />;
    case type === ALERT_TYPES.REVIEW:
      return (
        <Ring
          color={status === RULE_RESULT_STATUS_ID.CLEARED ? 'green' : 'red'}
        />
      );
    case status === RULE_RESULT_STATUS_ID.CLEARED:
      return canSeeVerification ? (
        <StyledCheckIcon
          size={size}
          icon={faCircleThreeQuartersStroke}
          data-testid="status-three-quarter"
        />
      ) : (
        <StyledCheckIcon
          size={size}
          icon={faCheckCircle}
          data-testid="status-check-circle"
        />
      );
    case type === ALERT_TYPES.PARENT:
      return (
        <StyledNotification
          size={size}
          required={required}
          data-testid="status-notification"
        >
          {numberOfChildren}
        </StyledNotification>
      );
    case type === ALERT_TYPES.CHILD:
      return (
        <StyledCircleIcon
          icon={faCircle}
          required={required}
          size={size}
          data-testid="status-circle"
        />
      );
    default:
      return null;
  }
};

StatusIcon.defaultProps = {
  required: false,
  size: 'small',
};

export default StatusIcon;
